import { isDefined } from '../functions/index.js';
export const changeDate = ({ date, unit, delta }) => {
    if (!isDefined(date)) {
        return date;
    }
    const value = date instanceof Date ? new Date(date.getTime()) : new Date(date);
    if (unit === 'seconds') {
        value.setSeconds(value.getSeconds() + delta);
    }
    if (unit === 'minutes') {
        value.setMinutes(value.getMinutes() + delta);
    }
    if (unit === 'months') {
        value.setMonth(value.getMonth() + delta);
    }
    if (unit === 'years') {
        value.setFullYear(value.getFullYear() + delta);
    }
    return value;
};
export const nowInISO = () => new Date().toISOString();
